import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilitaService } from 'src/app/services/utilita.service';
import { MatSnackBar } from '@angular/material/snack-bar';

export class Documenti {

  public idPdf?: number;
  public FileName?: string;
  public DataInserimento?: Date;
  public Visibile?: number;
  public idUtentiProfilo?: number;

  public sFileBase64: string;

  constructor() {
    this.FileName = "";
    this.DataInserimento = new Date();
    this.Visibile = 0;
    this.idUtentiProfilo = JSON.parse(localStorage.getItem('username') || '0').idUtentiProfilo;
    this.sFileBase64 = "";

    //  this.selectedNations = [""];
  }

}


@Component({
  selector: 'app-bilanci',
  templateUrl: './bilanci.component.html',
  styleUrls: ['./bilanci.component.css']
})
export class BilanciComponent implements OnInit {
  public objdoc: Documenti = new Documenti();
  @ViewChild("fileInput") fileInput: any; fileInputresult: any;


  constructor(
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  changeListener(event: any): void {
    this.readThis(event.target);
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.fileInputresult = myReader.result;
    }
    myReader.readAsDataURL(file);
  }


  resetInputFile() {
    this.fileInput.nativeElement.value = "";
  }



  btnUpload() {
    if (this.fileInput.nativeElement.files && this.fileInput.nativeElement.files[0]) {
      this.objdoc.FileName = this.fileInput.nativeElement.files[0].name;
      this.objdoc.sFileBase64 = this.fileInputresult.split(',')[1];




  this.srvUtilita.postObj('Tabelle/UploadDocumentoPDF', this.objdoc).subscribe((res: any) => {
        this.showMessage('File caricato con successo. ', 'OK');
        this.resetInputFile();
      }, (err: any) => {
      //  console.log(err);
        this.showMessage('Attenzione: ' + err.error.Message, 'OK'); 
        this.resetInputFile();
      })

    } else {
      this.showMessage('Attenzione, nessun file caricato. ', 'OK');
    }
}

 
  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

  

}




